<template>
  <div class="flex justify-center">
    <div class="layup-loader">
      <div class="layup-shadow layup-shadow-1" />
      <div class="layup-box layup-box-1" />
      <div class="layup-shadow layup-shadow-2" />
      <div class="layup-box layup-box-2" />
      <div class="layup-shadow layup-shadow-3" />
      <div class="layup-box layup-box-3" />
    </div>
  </div>
</template>
